<template>
    <Header></Header>
    <div class="container sub_page _activity">
        <section class="sub_page_tit">
            <div class="deco_wrap">
                <i class="deco_01"><img src="img/activity_left.png" /></i>
                <i class="deco_02 _small blink4"><img src="img/b_icon_01.png" /></i>
                <i class="deco_03 _small blink_zoom1"><img src="img/b_icon_02.png" /></i>
                <i class="deco_04 _xxsmall blink_zoom4"><img src="img/b_icon_05.png" /></i>
                <i class="deco_05 none_768 spin2 _medium"><img src="img/b_icon_03.png" /></i>
                <i class="deco_06 none_768 spin_blink3 _small"><img src="img/b_icon_01.png" /></i>
                <i class="deco_07 none_768 blink_zoom4 _small"><img src="img/b_icon_02.png" /></i>
                <i class="deco_character"><img src="img/activity_icon.png" /></i>
            </div>
            <div class="banner_wrap wrap_1120">
                <h2>시민참여 활동</h2>
            </div>
            <div class="sub_menu_tab wrap_1120" ref="header">
                <button class="only_768" @click="subMenuTab" :class="{ active: state.subMenuOpen }">{{ state.subMenuName }}</button>
                <ul :class="{ active: state.subMenuOpen }">
                    <li @click="changeTab(1)" :class="[state.tab === 1 ? 'active' : '']"><a href="javascript:void(0)">반성매매 시민활동</a></li>
                    <li @click="changeTab(2)" :class="[state.tab === 2 ? 'active' : '']"><a href="javascript:void(0)">캠페인·이벤트</a></li>
                    <li @click="changeTab(3)" :class="[state.tab === 3 ? 'active' : '']">
                        <a href="javascript:void(0)">참여하고 싶은 반성매매 활동 제안</a>
                    </li>
                    <li v-if="user.isLogin()" @click="changeTab(4)" :class="[state.tab === 4 ? 'active' : '']" class="w_1024_custom_width">
                        <a href="javascript:void(0)">액션 시민 활동</a>
                    </li>
                </ul>
            </div>
        </section>
        <section class="sub_page_con wrap_1120">
            <div class="bread_crumbs">
                <router-link to="/" class="icon_wrap"><img src="img/home_icon.png" alt="홈" /></router-link>
                <!-- <span class="icon_wrap"><img src="img/part_icon.png" alt="시민참여 활동" /></span>
                <a href="">시민참여 활동</a> -->
                <span class="icon_wrap"><img src="img/part_icon.png" alt="반성매매 시민활동" /></span>
                <router-link :to="{ path: '/board', query: { type: 1 } }">반성매매 시민활동</router-link>
                <span class="icon_wrap"><img src="img/part_icon.png" alt="글쓰기" /></span>
                <span class="faq_list_title">글쓰기</span>
            </div>

            <div class="sub_page_con_view sign_form con_write">
                <div class="report_con">
                    <ul>
                        <li class="checkbox_wrap">
                            <span class="form_li_tit">제목</span>
                            <input type="text" placeholder="제목을 입력해주세요." v-model="form_state.title" />
                        </li>
                        <li class="date_wrap">
                            <span class="form_li_tit">활동기간</span>
                            <input type="date" placeholder="" v-model="form_state.activityStartDate" />
                            <em>~</em>
                            <input type="date" placeholder="" v-model="form_state.activityEndDate" />
                        </li>
                        <li class="date_wrap">
                            <span class="form_li_tit">모집기간</span>
                            <input type="date" placeholder="" v-model="form_state.recruitmentStartDate" />
                            <em>~</em>
                            <input type="date" placeholder="" v-model="form_state.recruitmentEndDate" />
                        </li>
                        <li class="">
                            <span class="form_li_tit">모집인원</span>
                            <input type="text" class="w_100" placeholder="" v-model="form_state.cntMember" />
                            명
                        </li>
                        <li class="date_wrap">
                            <span class="form_li_tit">신청 종료일</span>
                            <input type="date" placeholder="" v-model="form_state.endDate" />
                        </li>
                        <li class="add_wrap">
                            <label for="area_address" class="form_li_tit">주소</label>
                            <input
                                id="area_address"
                                readonly
                                type="text"
                                class="code _blocked"
                                placeholder="우편번호"
                                v-model="form_state.zipCode"
                                @click="searchAddress"
                            />
                            <button class="blue_btn w_120" @click="searchAddress">검색</button>

                            <input id="area_address" readonly type="text" class="text _blocked" placeholder="주소" v-model="form_state.address" />
                            <input id="area_address2" type="text" placeholder="상세주소" v-model="form_state.addressDetail" />
                        </li>
                        <li class="con_form">
                            <span class="form_li_tit">내용</span>
                            <textarea id="editor1" name="editor1"></textarea>
                        </li>
                        <li class="con_form">
                            <span class="form_li_tit">
                                개인정보 수집
                                <br v-if="!state.isMobile" />
                                및 이용 동의
                            </span>
                            <textarea id="editor2" name="editor2"></textarea>
                        </li>
                        <li class="file_wrap">
                            <span class="form_li_tit">첨부</span>
                            <label for="area_file">
                                <input id="area_file" type="file" placeholder="" accept="image/*" multiple @change="handleFiles" />
                                <template v-if="!state.isMobile">
                                    <div class="file_box_wrap">‘파일첨부’ 버튼을 클릭하여 첨부해주세요</div>
                                    <span class="blue_btn" style="display: flex; justify-content: center; align-items: center">파일첨부</span>
                                    <p class="p_info">200M 이하 JPG, PNG 파일을 첨부해주세요.</p>
                                </template>
                                <template v-else>
                                    <p class="p_info">200M 이하 JPG, PNG 파일을 첨부해주세요.</p>
                                    <span class="blue_btn" style="display: flex; justify-content: center; align-items: center">파일첨부</span>
                                </template>
                            </label>
                            <div class="file_list">
                                <div class="file" v-for="(item, idx) in form_state.file" :key="idx">
                                    <span class="file_name" @click="downloadFile(item.file, item.imgRealName)">{{ item.imgRealName }}</span>
                                    <button class="file_del icon_wrap" @click="fileRemove(item.idx)">
                                        <img src="img/close_02.png" alt="" />
                                    </button>
                                </div>

                                <div class="file" v-for="(item, index) in state.file" :key="index">
                                    <span class="file_name">{{ item.name }}</span>
                                    <button class="file_del icon_wrap" @click="removeNewFile(index)">
                                        <img src="img/close_02.png" alt="" />
                                    </button>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <!-- 하단 업소추가 버튼 클릭시 div.report_con 반복 끝-->
            </div>

            <div class="btn_wrap _default left_right_btn _1_2">
                <button class="common_btn _gray w_130" @click="router.go(-1)">취소</button>
                <button class="common_btn w_130" @click="state.isShowPreview = true" v-if="!state.isMobile">미리보기</button>
                <button class="common_btn w_130" @click="save">작성완료</button>
            </div>
        </section>
    </div>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>

    <ModalPreviewForBoard
        v-if="state.isShowPreview"
        :type="'activity'"
        :header="header.innerHTML"
        :title="form_state.title"
        :content="form_state.content"
        :data="form_state"
        @close="state.isShowPreview = false"
    ></ModalPreviewForBoard>
    <Footer></Footer>
</template>

<script lang="ts" config>
    import {
        reactive,
        globalStore,
        userStore,
        onMounted,
        onBeforeMount,
        watch,
        useRoute,
        Header,
        Footer,
        router,
        apiService,
        types,
        ModalDefault,
        ModalPreviewForBoard,
        ref,
        CommonUtils,
        CkEditorManager,
        onUnmounted,
        getMessageByCode,
        onBeforeUnmount,
    } from "@/BaseComponent";

    export default {
        components: { Header, Footer, ModalDefault, ModalPreviewForBoard },
        setup() {
            const route = useRoute();
            const global = globalStore();
            const user = userStore();
            const state = reactive({
                tab: 1 as number,
                idx: 0 as number,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                isShowPreview: false as boolean,

                isAuth: false,
                file: [] as Array<File>,

                subMenuOpen: false,
                subMenuName: "반성매매 시민활동" as string,

                isMobile: false,
            });

            const form_state = reactive({
                title: "" as string,
                content: "" as string,
                term: "" as string,
                activityStartDate: "" as string,
                activityEndDate: "" as string,
                recruitmentStartDate: "" as string,
                recruitmentEndDate: "" as string,
                endDate: "" as string,
                cntMember: 0 as number,
                zipCode: "" as string,
                address: "" as string,
                addressDetail: "" as string,

                file: [] as Array<types.ResBoardFileVOForApi>,
            });
            const header = ref();

            let editorManager: CkEditorManager | null = null;
            let editorManagerTerm: CkEditorManager | null = null;

            onBeforeMount(() => {
                if (
                    !(
                        user.isLogin() &&
                        (user.userInfo.gubun === 1 ||
                            (user.userInfo.isAdmin &&
                                user.roles != null &&
                                user.roles.some((item: types.RoleVO) => item.key.indexOf("activity") > -1)))
                    )
                ) {
                    state.modalTab = -1;
                    state.modalTitle = "안내";
                    state.modalContent = "권한이 없습니다.";
                    state.isShowModal = true;
                }
            });

            onMounted(async () => {
                const idx = Number(route.params.id);
                if (route.params.id) {
                    if (idx && typeof idx === "number" && !isNaN(idx)) {
                        state.idx = idx;

                        if (user.isLogin()) {
                            await getDetail();

                            editorManager = new CkEditorManager("editor1", form_state, "suggestion");
                            await editorManager.initEditor();

                            const term = { content: form_state.term };
                            editorManagerTerm = new CkEditorManager("editor2", term, "suggestion");
                            await editorManagerTerm.initEditor();
                        } else {
                            state.modalTab = -1;
                            state.modalTitle = "안내";
                            state.modalContent = "접근 권한이 없습니다.";
                            state.isShowModal = true;
                        }
                    } else {
                        router.back();
                    }
                } else {
                    editorManager = new CkEditorManager("editor1", form_state, "suggestion");
                    await editorManager.initEditor();

                    const term = { content: form_state.term ? form_state.term : "" };
                    editorManagerTerm = new CkEditorManager("editor2", term, "suggestion");
                    await editorManagerTerm.initEditor();
                }

                state.isMobile = window.innerWidth < 768;
            });

            onBeforeUnmount(() => {
                editorManager?.destroy();
                editorManagerTerm?.destroy();
            });

            watch(
                () => route.params.id,
                () => {
                    const idx = Number(route.params.id);
                    state.idx = idx;
                    getDetail();
                },
            );

            const getDetail = async () => {
                const res = await apiService.boardActivity.detail(state.idx);

                if (res.returnCode === 0) {
                    form_state.title = res.data.title;
                    form_state.content = res.data.content;
                    form_state.term = CommonUtils.decodeContent(res.data.term);
                    form_state.file = res.data.fileList;

                    form_state.activityStartDate = CommonUtils.dateFormat(res.data.activeStartDate, "-", false);
                    form_state.activityEndDate = CommonUtils.dateFormat(res.data.activeEndDate, "-", false);
                    form_state.recruitmentStartDate = CommonUtils.dateFormat(res.data.recruitStartDate, "-", false);
                    form_state.recruitmentEndDate = CommonUtils.dateFormat(res.data.recruitEndDate, "-", false);
                    form_state.endDate = CommonUtils.dateFormat(res.data.applyDate, "-", false);
                    form_state.cntMember = res.data.cntApply;
                    form_state.zipCode = res.data.zipCode;
                    form_state.address = res.data.address;
                    form_state.addressDetail = res.data.addressDetail;

                    await editorManager?.setDataInfo(form_state.content);
                    await editorManagerTerm?.setDataInfo(res.data.term);
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const changeTab = (tab: number) => {
                global.setBoardTab(tab);
                router.push("/board?type=" + tab);
                state.subMenuOpen = false;
                switch (tab) {
                    case 1:
                        state.subMenuName = "반성매매 시민활동";
                        break;
                    case 2:
                        state.subMenuName = "캠페인·이벤트";
                        break;
                    case 3:
                        state.subMenuName = "참여하고 싶은 반성매매 활동 제안";
                        break;
                }
            };

            const subMenuTab = () => {
                if (window.innerWidth <= 768) {
                    state.subMenuOpen = !state.subMenuOpen;
                }
            };

            const searchAddress = async () => {
                new window.daum.Postcode({
                    oncomplete: (data: any) => {
                        form_state.zipCode = data.zonecode; // 우편번호
                        form_state.address = data.address; // 전체 주소
                    },
                }).open();
            };

            const fileRemove = async (idxFile: number) => {
                const res = await apiService.boardSuggest.removeFile(state.idx, idxFile);
                if (res.returnCode === 0) {
                    const index = form_state.file.findIndex((item) => item.idx === idxFile);
                    if (index !== -1) {
                        form_state.file.splice(index, 1);
                    }
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = 8;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const downloadFile = async (fileUrl: string, fileName: string) => {
                const res = await fetch(fileUrl);
                const blob = await res.blob();
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
                URL.revokeObjectURL(link.href);
            };

            const closeModal = () => {
                state.isShowModal = false;

                if (state.idx > 0 && state.modalTab === -1) router.replace({ name: "ActivityView", params: { id: state.idx } });
                else if (state.modalTab !== 8) router.replace("/board?type=1");
            };

            const callBackModal = async (param: any) => {
                state.isShowModal = false;
            };

            const handleFiles = (e: any) => {
                const target = e.target as HTMLInputElement;
                if (!target.files) return;

                const files: File[] = Array.from(target.files);

                const isFiles = files.filter((file) => !file.type.startsWith("image/"));

                if (isFiles.length > 0) {
                    state.modalTab = 8;
                    state.modalTitle = "알림";
                    state.modalContent = "이미지 파일만 업로드할 수 있습니다.";
                    state.isShowModal = true;

                    target.value = "";
                    return;
                }

                state.file = files;
                target.value = "";
            };

            const removeNewFile = (index: number) => {
                state.file.splice(index, 1);
            };

            const save = async () => {
                form_state.content = (await editorManager?.getData()) + "";
                if (!(form_state.title && form_state.content)) {
                    state.modalTab = 7;
                    state.modalTitle = "알림";
                    state.modalContent = "제목과 내용을 입력해주세요.";
                    state.isShowModal = true;
                } else if (
                    form_state.activityStartDate === "" ||
                    form_state.activityEndDate === "" ||
                    form_state.activityEndDate <= form_state.activityStartDate
                ) {
                    state.modalTab = 7;
                    state.modalTitle = "알림";
                    state.modalContent = "활동 기간을 확인해주세요.";
                    state.isShowModal = true;
                } else if (
                    form_state.recruitmentStartDate === "" ||
                    form_state.recruitmentEndDate === "" ||
                    form_state.recruitmentEndDate <= form_state.recruitmentStartDate
                ) {
                    state.modalTab = 7;
                    state.modalTitle = "알림";
                    state.modalContent = "모집 기간을 확인해주세요.";
                    state.isShowModal = true;
                } else if (form_state.endDate === "") {
                    state.modalTab = 7;
                    state.modalTitle = "알림";
                    state.modalContent = "신청 종료일을 확인해주세요.";
                    state.isShowModal = true;
                } else if (!((await editorManagerTerm?.getData()) + "")) {
                    state.modalTab = 7;
                    state.modalTitle = "알림";
                    state.modalContent = "개인정보 수집 및 이용 동의 내용을 입력해주세요";
                    state.isShowModal = true;
                } else {
                    if (!(state.idx > 0)) {
                        const param: types.ReqBoardForActivity = {
                            title: form_state.title,
                            content: form_state.content,
                            term: (await editorManagerTerm?.getData()) + "",
                            activityStartDate: form_state.activityStartDate,
                            activityEndDate: form_state.activityEndDate,
                            recruitmentStartDate: form_state.recruitmentStartDate,
                            recruitmentEndDate: form_state.recruitmentEndDate,
                            endDate: form_state.endDate,
                            cntMember: form_state.cntMember,
                            zipCode: form_state.zipCode,
                            address: form_state.address,
                            addressDetail: form_state.addressDetail,
                            file: state.file,
                        };
                        const res = await apiService.boardActivity.add(param);
                        if (res.returnCode === 0) {
                            state.modalTab = -1;
                            state.modalTitle = "안내";
                            state.modalContent = getMessageByCode(res.returnCode);
                            state.isShowModal = true;
                        } else if (res.returnCode === 11) {
                        } else {
                            state.modalTab = 8;
                            state.modalTitle = "예외 발생";
                            state.modalContent = getMessageByCode(res.returnCode);
                            state.isShowModal = true;
                        }
                    } else {
                        const param: types.ReqBoardForActivityForModify = {
                            title: form_state.title,
                            content: form_state.content,
                            term: (await editorManagerTerm?.getData()) + "",
                            activityStartDate: form_state.activityStartDate,
                            activityEndDate: form_state.activityEndDate,
                            recruitmentStartDate: form_state.recruitmentStartDate,
                            recruitmentEndDate: form_state.recruitmentEndDate,
                            endDate: form_state.endDate,
                            cntMember: form_state.cntMember,
                            zipCode: form_state.zipCode,
                            address: form_state.address,
                            addressDetail: form_state.addressDetail,
                            file: state.file,
                            memo: null,
                        };

                        if (state.file && state.file.length > 0) {
                            param.file = state.file;
                        }

                        const res = await apiService.boardActivity.modify(state.idx, param);
                        if (res.returnCode === 0) {
                            state.modalTab = -1;
                            state.modalTitle = "안내";
                            state.modalContent = "저장이 완료되었습니다.";
                            state.isShowModal = true;
                        } else if (res.returnCode === 11) {
                        } else {
                            state.modalTab = 8;
                            state.modalTitle = "예외 발생";
                            state.modalContent = getMessageByCode(res.returnCode);
                            state.isShowModal = true;
                        }
                    }
                }
            };

            return {
                state,
                user,
                form_state,
                changeTab,
                subMenuTab,
                searchAddress,
                fileRemove,
                downloadFile,
                closeModal,
                callBackModal,
                router,
                removeNewFile,
                save,
                handleFiles,
                header,
                CommonUtils,
            };
        },
    };
</script>
<style>
    .faq_list_title {
        color: #6d6d6d;
        font-size: 14px;
        font-weight: 500;
    }
</style>
